// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__1seWF","modalContent":"style_modalContent__4SBar","modalBtn":"style_modalBtn__AfHuH"};